// import { MemberActionType } from '../../actions/member/memberTypes';
import { StoreVoActionType } from '@/reducers/V2/V2Actions/StoreVo/StoreVoTypes';

const initialState: any = {
  storeUuid: '',
  locales: ['zh-tw'],
  phone: '',
  address: '',
  displayName: '',
  name: '',
  identifier: null,
  brandImageUrl: '',
  seatOvertimeMins: 0,
  shareMealConditions: [],
  fb: '',
  line: '',
  startTime: '',
  endTime: '',
  isCouponEnable: true,
  isRoyaltyEnable: true,
  isOtpEnabled: false,
  payMethods: [],
  currency: 'TWD',
  roundingScale: 0,
  preorderTimeMap: [],
  webUiConfig: { showRequireComments: true, showItemComment: false },
  genericRules: [],
  tradingLocations: [],
  takeoutKitchenReceipt: '',
  availableServeTypes: [],
  quantityEditable: false,
};

const StoreVoReducer: (state: any, action: any) => any = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case StoreVoActionType.SET_STORE_VO_UUID:
      return {
        ...state,
        storeUuid: payload,
      };
    case StoreVoActionType.SET_STORE_VO_NAME:
      return {
        ...state,
        name: payload,
      };
    case StoreVoActionType.SET_STORE_VO_DISPLAYNAME:
      return {
        ...state,
        displayName: payload,
      };
    case StoreVoActionType.SET_STORE_VO_IDENTIFIER:
      return {
        ...state,
        identifier: payload,
      };
    case StoreVoActionType.SET_STORE_VO_BRAND_IMG_URL:
      return {
        ...state,
        brandImageUrl: payload,
      };
    case StoreVoActionType.SET_STORE_VO_START:
      return {
        ...state,
        startTime: payload,
      };
    case StoreVoActionType.SET_STORE_VO_END:
      return {
        ...state,
        endTime: payload,
      };
    case StoreVoActionType.SET_STORE_VO_PHONE:
      return {
        ...state,
        phone: payload,
      };
    case StoreVoActionType.SET_STORE_VO_ADDRESS:
      return {
        ...state,
        address: payload,
      };
    case StoreVoActionType.SET_STORE_VO_FB:
      return {
        ...state,
        fb: payload,
      };
    case StoreVoActionType.SET_STORE_VO_LINE:
      return {
        ...state,
        line: payload,
      };
    case StoreVoActionType.SET_STORE_VO_LOCALES:
      return {
        ...state,
        locales: payload,
      };
    case StoreVoActionType.SET_STORE_VO_COUPON_ENABLE:
      return {
        ...state,
        isCouponEnable: payload,
      };
    case StoreVoActionType.SET_STORE_VO_ROYALTY_ENABLE:
      return {
        ...state,
        isRoyaltyEnable: payload,
      };
    case StoreVoActionType.SET_STORE_VO_PAY_METHODS:
      return {
        ...state,
        payMethods: payload,
      };
    case StoreVoActionType.SET_STORE_VO_CURRENCY:
      return {
        ...state,
        currency: payload,
      };
    case StoreVoActionType.SET_STORE_VO_ROUNDING_SCALE:
      return {
        ...state,
        roundingScale: payload,
      };
    case StoreVoActionType.SET_STORE_VO_PREORDERTIME_MAP:
      return {
        ...state,
        preorderTimeMap: payload,
      };

    case StoreVoActionType.SET_STORE_VO_WEB_UI_CONFIG:
      return {
        ...state,
        webUiConfig: payload,
      };
    case StoreVoActionType.SET_STORE_VO_WEB_GENERIC_RULES:
      return {
        ...state,
        genericRules: payload,
      };
    case StoreVoActionType.SET_STORE_VO_SHAREMEAL_CONDITIONS:
      return {
        ...state,
        shareMealConditions: payload,
      };
    case StoreVoActionType.SET_STORE_VO_IS_OTP_ENABLE:
      return {
        ...state,
        isOtpEnabled: payload,
      };
    case StoreVoActionType.SET_STORE_VO_TRADING_LOCATIONS:
      return {
        ...state,
        tradingLocations: payload,
      };
    case StoreVoActionType.SET_STORE_VO_TAKEOUT_KITCHEN_RECEIPT:
      return {
        ...state,
        takeoutKitchenReceipt: payload,
      };
    case StoreVoActionType.SET_STORE_VO_AVAILABLE_SERVETYPES:
      return {
        ...state,
        availableServeTypes: payload,
      };
    case 'SET_STORE_VO_FB':
      return {
        ...state,
        fb: payload,
      };
    case 'SET_STORE_VO_LINE':
      return {
        ...state,
        line: payload,
      };
    case StoreVoActionType.SET_STORE_VO_IS_QUANTITY_EDIT_ENABLED:
      return {
        ...state,
        quantityEditable: payload,
      };
    default:
      return state;
  }
};

export default StoreVoReducer;
